import React from 'react';
import { compose } from 'recompose';
import RRDPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { FirebasePropType, withFirebase } from '../../../model/Firebase';
import { withAuthorization } from '../../../model/Session';
import { isLolaAdmin } from '../../../components/access';
import * as ROUTES from '../../../constants/routes';
import Loading from '../../../components/loading';
import ArtistaForm from './form';
import PanelSocial from '../../../components/social/panelSocial';
import FullWidthContainer from '../../../components/dashboard/fullWidthContainer';
import MPanel from '../../../components/panel';
import PanelObras from './Obras/panel';
import Fields from './fields';

const EditArtista = ({
  firebase, match, history,
}) => {
  const [artista, setArtista] = React.useState(JSON.parse(JSON.stringify(Fields.defaultValues())));
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const { id } = match.params;
    let unsubscribe;
    if (id) {
      setLoading(true);
      unsubscribe = firebase.artista(id).onSnapshot((snap) => {
        if (snap.exists) {
          const data = Fields.getInstance(snap);
          setArtista(data);
          setLoading(false);
        } else {
          history.push(ROUTES.ARTISTAS);
        }
      }, () => history.push(ROUTES.ARTISTAS));
    } else {
      history.push(ROUTES.ARTISTAS);
    }
    return () => !!unsubscribe && unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FullWidthContainer
      backPath={ROUTES.ARTISTAS}
      title={loading ? 'Cargando artista...' : `Artista: ${artista.name}`}
    >
      <Grid container spacing={3} justify="center">
        {loading ? (
          <Grid item xs={12} md={6}>
            <Loading />
          </Grid>
        ) : (
          <>
            <Grid item xs={12} md={6}>
              <MPanel withPaper>
                <ArtistaForm isNew={false} artistaValues={artista} />
              </MPanel>
            </Grid>
            <Grid item xs={12} md={6}>
              <PanelSocial entity="artista" editCondition={isLolaAdmin} message="Redes sociales / Enlaces" object={artista} />
              <PanelObras artista={artista} />
            </Grid>
          </>
        )}
      </Grid>
    </FullWidthContainer>
  );
};

EditArtista.propTypes = {
  firebase: FirebasePropType.isRequired,
  match: RRDPropTypes.match.isRequired,
  history: RRDPropTypes.history.isRequired,
};

export default compose(
  withAuthorization(isLolaAdmin),
  withRouter,
  withFirebase,
)(EditArtista);
